import { UserRole } from 'enums/user';
import { PermissionActions, PermissionSubjects } from 'configs/permissionConstants';
import { Permissions } from './ability';

/**
 * Content Items are open to any authenticated user (ADMIN or CONTENT_EDITOR).
 * /api/users/** and /api/audit-log require ADMIN.
 * See the UAM CMS Backend Postman collection's collection-level description.
 */
export function getRolePermissions(role: UserRole): Permissions[] {
  const permissions: Permissions[] = [
    { action: PermissionActions.VIEW, subject: PermissionSubjects.DASHBOARD },
    { action: PermissionActions.VIEW, subject: PermissionSubjects.CONTENT_ITEMS },
    { action: PermissionActions.CREATE, subject: PermissionSubjects.CONTENT_ITEMS },
    { action: PermissionActions.EDIT, subject: PermissionSubjects.CONTENT_ITEMS },
    { action: PermissionActions.PUBLISH, subject: PermissionSubjects.CONTENT_ITEMS },
  ];

  if (role === UserRole.ADMIN) {
    permissions.push(
      { action: PermissionActions.MANAGE, subject: PermissionSubjects.USER_MANAGEMENT },
      { action: PermissionActions.VIEW, subject: PermissionSubjects.ACTIVITY_LOGS },
    );
  }

  return permissions;
}
